import { APP_CONSTANTS } from '../../../common/config/app-constants';
import { httpGetJSON } from '../../../common/services/ajax-services';
import { roundToAtMaxNDigits } from '../../../common/util';

const { GET_TEST_FREAK_BASE } = APP_CONSTANTS;

export type ReviewType = 'user' | 'your' | 'expert';

export function getTestFreaksReviewsForProductIdAsync(productId: string) {
  const tfBase = GET_TEST_FREAK_BASE;
  const params = { key: productId, '-*': true };
  return httpGetJSON(tfBase, params, {}, false);
}

export async function getTestFreaksReviewCommentsForProductIdAsync(productId: string, minimumCommentsCount: number) {
  return new Promise(resolve => {
    const review_url_order = ['user_review_url', 'pro_review_url', 'your_review_url'];
    let reviews = [];
    let noOfReviews = 0;
    let rating = 0;
    getTestFreaksReviewsForProductIdAsync(productId).then(reviewFirstAPIResponse => {
      if ('user_review_count' in reviewFirstAPIResponse) noOfReviews += reviewFirstAPIResponse.user_review_count;
      if ('pro_review_count' in reviewFirstAPIResponse) noOfReviews += reviewFirstAPIResponse.pro_review_count;
      if ('your_review_count' in reviewFirstAPIResponse) noOfReviews += reviewFirstAPIResponse.your_review_count;

      if ('score' in reviewFirstAPIResponse) rating = roundToAtMaxNDigits(reviewFirstAPIResponse.score / 2, 10);

      if (minimumCommentsCount === 0) {
        resolve({ reviews, noOfReviews, rating });
        return;
      }
      for (const urlKey of review_url_order) {
        if (urlKey in reviewFirstAPIResponse) {
          const url = reviewFirstAPIResponse[urlKey];
          httpGetJSON(url, { '-*': true }, {}, false).then(response => {
            // const response = await httpGetJSON(url, { '-*': true }, {}, false);
            if (response?.reviews?.length > 0) {
              reviews = [...reviews, ...response.reviews];
              if (reviews.length >= minimumCommentsCount) return;
            }
          });
        }
      }
      resolve({ reviews, noOfReviews, rating });
    });
  });
}
